import { LoadingButton } from '@mui/lab';
import { Button, DialogTitle, CardContent, ListItemIcon, Paper } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { useTranslation } from 'react-i18next';

const YoutubeAuthorizationModal = (props) => {
  const { t: translate } = useTranslation();
  const [isLoadingOn, setLoadingOn] = useState(false);

  const handleConnectYoutube = () => {
    setLoadingOn(true);
    props.handleConnectYoutube();
  };

  const handleClose = () => {
    props.handleClose();
  };

  return (
    <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open>
      <DialogTitle id="customized-dialog-title">
        <Typography gutterBottom variant="h4">
          {props.reAuth
            ? `${translate('integration.youtube.reauthenticate_youtube_account')}`
            : `${translate('integration.youtube.have_you_converted_your_youtube_account')}?`}
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <CardContent sx={{ p: { xs: 0, md: 0 }, color: 'grey.800' }}>
          <Typography variant="body1" sx={{ mx: 'auto', fontWeight: 'bold' }}>
            {props.reAuth
              ? `${translate('common.verify_these_requirements')}:`
              : `${translate('common.make_sure_completed_steps')}:`}
          </Typography>

          <Paper sx={{ display: 'flex', alignItems: 'flex-start', mb: 1, mt: 2 }}>
            <ListItemIcon>
              <VerifiedUserIcon sx={{ color: 'success.dark', width: 18, height: 18, ml: 2, mt: 0.5 }} />
            </ListItemIcon>
            <Typography variant="body1">
              {props.reAuth
                ? `${translate('integration.youtube.confirm_google_account')}`
                : `${translate('integration.youtube.signed_your_google_account')}`}
            </Typography>
          </Paper>

          <Paper sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
            <ListItemIcon>
              <VerifiedUserIcon sx={{ color: 'success.dark', width: 18, height: 18, ml: 2, mt: 0.5 }} />
            </ListItemIcon>
            <Typography variant="body1">
              {props.reAuth
                ? `${translate('integration.youtube.privacy_security_standards')}`
                : `${translate('integration.youtube.security_users_data')}`}
            </Typography>
          </Paper>

          {!props.reAuth && (
            <Paper sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
              <ListItemIcon>
                <VerifiedUserIcon sx={{ color: 'success.dark', width: 18, height: 18, ml: 2, mt: 0.5 }} />
              </ListItemIcon>
              <Typography variant="body1">{translate('integration.youtube.copyrights')}</Typography>
            </Paper>
          )}

          <Paper sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
            <ListItemIcon>
              <VerifiedUserIcon sx={{ color: 'success.dark', width: 18, height: 18, ml: 2, mt: 0.5 }} />
            </ListItemIcon>
            <Typography variant="body1">
              {props.reAuth
                ? `${translate('integration.youtube.youtube_channel_permissions')}`
                : `${translate('integration.youtube.youtube_channel_integration')}`}
            </Typography>
          </Paper>
        </CardContent>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="error" onClick={handleClose}>
          {translate('common.close')}
        </Button>
        <LoadingButton
          variant="contained"
          loading={isLoadingOn}
          autoFocus
          onClick={() => {
            handleConnectYoutube();
          }}
        >
          {props.reAuth ? `${translate('common.reconnect')}` : `${translate('common.connect')}`}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
export default YoutubeAuthorizationModal;
